<div class="content">

    <div class="d-flex justify-content-start mt-2">

        <div (click)="goToCustomersView()" style="cursor: pointer;">
            <div class="d-flex align-items-center">
                <i class="fa-solid fa-arrow-left"></i>
                <span>Back to Customers View</span>
            </div>
        </div>
    </div>

    


    <div class="d-flex justify-content-center">
        <h5>{{getTitle()}}</h5>
    </div>
    
    <div class="d-flex justify-content-center mt-4" >
        <ng-wizard [config]="config">

            
            <ng-wizard-step [title]="'Step 1'" [description]="'LO Global Customer Data'">
                <app-customer-leadoperator *ngIf="viewCustomerDataLeadOperator()" [customerDto]="createCustomerDto"
                    [isDisableFormLeadOperator]="isDisableFormLeadOperator" [isModifica]="isModifica"
                    (updateCustomerDataLeadOperatorItemEvent)="updateCustomerDto($event)"
                    (changeCreationStepCustomerDataLeadOperatorItemEvent)="changeStepView($event)"></app-customer-leadoperator>
            </ng-wizard-step>

            <ng-wizard-step [title]="'Step 2'" [description]="'BO Global Customer Data'">
                <app-customer-boperator *ngIf="viewCustomerDataBOperator()" [customerDto]="createCustomerDto"
                    [isDisabledFormBOperator]="isDisabledFormBOperator" [isModifica]="isModifica"
                    [tendinaAgreements]="tendinaAgreements"
                    (updateCustomerDataBOperatorItemEvent)="updateCustomerDto($event)"
                    (changeCreationStepCustomerDataBoperatorItemEvent)="changeStepView($event)"
                    (previousStepEvent)="previousStepView($event)"></app-customer-boperator>
            </ng-wizard-step>

            

            <ng-wizard-step [title]="'Step 3'" [description]="'Customer Data Country'">
                <app-customer-country *ngIf="viewCustomerDataCountry()" [customerDto]="createCustomerDto"
                    [isDisabledFormCountry]="isDisabledFormCountry"
                    [tendinaAgreements]="tendinaAgreements"
                    (updateCustomerDataCountryItemEvent)="updateCustomerDto($event)"
                    (previousStepEvent)="previousStepView($event)"
                    (changeCreationStepCustomerDataCountryItemEvent)="changeStepView($event)"
                    (saveCustomerCountryEvent)="saveCustomer($event)"></app-customer-country>
            </ng-wizard-step>

            <ng-wizard-step [title]="'Step 4'" [description]="'Customer Data Affiliate'">
                <app-customer-affiliate *ngIf="viewCustomerDataAffiliate()" [customerDto]="createCustomerDto"
                [isDisableFormAffiliate]="isDisableFormAffiliate"
                [tendinaAgreements]="tendinaAgreements"    
                (updateCustomerDataAffiliateItemEvent)="updateCustomerDto($event)"
                    (changeCreationStepCustomerDataAffiliateItemEvent)="changeStepView($event)"
                    (previousStepEvent)="previousStepView($event)" (saveCustomerAffiliateEvent)="saveCustomer($event)">
                </app-customer-affiliate>
            </ng-wizard-step>

            <ng-wizard-step [title]="'Step 5'" [description]="'Customer Data Department'">
                <app-customer-department *ngIf="viewCustomerDataDepartment()" [customerDto]="createCustomerDto"
                [tendinaAgreements]="tendinaAgreements"    
                (updateCustomerDataDepartmentItemEvent)="updateCustomerDto($event)"
                    (changeCreationStepCustomerDepartmentItemEvent)="changeStepView($event)"
                    (previousStepEvent)="previousStepView($event)" (saveCustomerDepartmentEvent)="saveCustomer($event)">
                </app-customer-department>
            </ng-wizard-step>

            
        </ng-wizard>

    </div>
</div>